var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileProfilePosts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M18 0v18H0V0zM5.5 12.5h-4v4h4zm5.5 0H7v4h4zm5.5 0h-4v4h4zM5.5 7h-4v4h4zM11 7H7v4h4zm5.5 0h-4v4h4zm-11-5.5h-4v4h4zm5.5 0H7v4h4zm5.5 0h-4v4h4z"
})));
export default SvgInstagramMobileProfilePosts;